var _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 806,
    height: 307,
    viewBox: "0 0 806 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.545 27.1556V14.2813H243.155C243.085 14.3985 243.014 14.5158 242.92 14.633C240.385 17.963 237.404 21.2696 234.422 24.5995L232.286 22.8173C235.033 19.6749 237.803 16.5794 240.174 13.4371C240.878 12.5225 241.16 11.4672 241.16 10.0602V5.65146H233.178V2.88429H244.235V9.96637C244.235 10.4823 244.211 10.9982 244.141 11.4438H247.521V1.85247H250.643V27.1556H247.521H247.545ZM253.812 27.9061V1.54761H256.958V27.9061H253.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.794 15.3132C262.169 15.3132 258.789 12.4522 258.789 8.32494C258.789 4.19764 262.169 1.33667 266.794 1.33667C271.418 1.33667 274.799 4.19764 274.799 8.32494C274.799 12.4522 271.418 15.3132 266.794 15.3132ZM261.723 27.6951V17.4707H281.959V27.6951H261.723ZM266.794 4.10384C263.86 4.10384 261.935 5.76883 261.935 8.32494C261.935 10.8811 263.86 12.5461 266.794 12.5461C269.728 12.5461 271.653 10.8811 271.653 8.32494C271.653 5.76883 269.728 4.10384 266.794 4.10384ZM278.813 20.2378H264.869V24.9045H278.813V20.2378ZM278.813 16.134V1.54773H281.959V16.1574H278.813V16.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.259 16.1808V13.4137H310.293V16.1808H284.259ZM292.288 11.4907C288.602 11.4907 286.043 9.47397 286.043 6.44885C286.043 3.42372 288.602 1.43042 292.288 1.43042H302.241C305.926 1.43042 308.485 3.42372 308.485 6.44885C308.485 9.47397 305.926 11.4907 302.241 11.4907H292.288ZM286.724 27.6951V18.5962H307.781V27.6951H286.724ZM292.569 4.10379C290.363 4.10379 289.189 4.97146 289.189 6.44885C289.189 7.92623 290.363 8.84081 292.569 8.84081H301.983C304.189 8.84081 305.363 7.92623 305.363 6.44885C305.363 4.97146 304.189 4.10379 301.983 4.10379H292.569ZM304.635 21.2462H289.87V25.0452H304.635V21.2462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.462 15.8291C313.837 15.8291 310.574 12.7805 310.574 8.65317C310.574 4.52587 313.837 1.47729 318.462 1.47729C323.086 1.47729 326.349 4.52587 326.349 8.65317C326.349 12.7805 323.086 15.8291 318.462 15.8291ZM330.293 27.9999V20.8475H313.391V18.0803H333.439V27.9999H330.293ZM318.462 4.19756C315.598 4.19756 313.72 6.02671 313.72 8.65317C313.72 11.2796 315.598 13.1088 318.462 13.1088C321.326 13.1088 323.204 11.2796 323.204 8.65317C323.204 6.02671 321.326 4.19756 318.462 4.19756ZM330.293 16.7436V1.54765H333.439V7.26959H336.983V10.1071H333.439V16.7436H330.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.317 5.01829H344.495V2.22767H358.439V7.99652C358.439 10.1071 357.782 11.092 355.88 11.9128C352.383 13.4136 348.251 15.0551 344.425 16.4622L343.228 14.0468C346.913 12.6397 351.021 11.0216 354.073 9.61461C354.988 9.1925 355.317 8.70004 355.317 7.48061V5.01829ZM352.383 27.8826C348.603 27.8826 345.88 25.7721 345.88 22.489C345.88 19.2059 348.603 17.0953 352.383 17.0953H361.021C364.801 17.0953 367.524 19.2059 367.524 22.489C367.524 25.7721 364.801 27.8826 361.021 27.8826H352.383ZM352.57 19.8391C350.481 19.8391 349.049 20.7536 349.049 22.4655C349.049 24.1774 350.505 25.092 352.57 25.092H360.834C362.923 25.092 364.378 24.1774 364.378 22.4655C364.378 20.7536 362.923 19.8391 360.834 19.8391H352.57ZM363.674 16.2277V13.2964H358.392V10.5526H363.674V7.1523H359.636V4.40858H363.674V1.54761H366.82V16.2277H363.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.942 20.7771V14.0233H383.792C382.36 15.5711 380.294 16.5325 377.806 16.5325C373.181 16.5325 369.918 13.2025 369.918 9.07525C369.918 4.94794 373.181 1.61796 377.806 1.61796C380.365 1.61796 382.524 2.64979 383.909 4.26788H389.942V1.54761H393.088V20.8005H389.942V20.7771ZM372.853 27.695V18.7134H375.998V24.9278H393.722V27.695H372.853ZM377.806 4.33823C374.942 4.33823 373.064 6.44878 373.064 9.07525C373.064 11.7017 374.942 13.8123 377.806 13.8123C380.67 13.8123 382.548 11.7017 382.548 9.07525C382.548 6.44878 380.67 4.33823 377.806 4.33823ZM389.942 7.12885H385.412C385.6 7.76201 385.693 8.41863 385.693 9.0987C385.693 9.84912 385.576 10.5526 385.388 11.2093H389.942V7.12885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.703 23.216V2.86084H408.112V5.62801H399.825V20.4488H408.91V23.216H396.68H396.703ZM417.478 27.9061V14.1406H413.863V27.1322H410.741V1.85247H413.863V11.3265H417.478V1.54761H420.624V27.9061H417.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.291 24.6466V22.0201H430.272V19.3936C426.563 18.9715 424.333 16.9548 424.333 13.9062C424.333 10.4589 427.244 8.32494 431.892 8.32494C436.54 8.32494 439.451 10.4589 439.451 13.9062C439.451 16.9548 437.197 18.9715 433.511 19.3936V22.0201H441.704V24.6466H422.337H422.291ZM423.582 7.15242V4.52595H430.295V1.33667H433.441V4.52595H440.155V7.15242H423.605H423.582ZM431.845 10.8811C429.075 10.8811 427.431 12.2177 427.431 13.9062C427.431 15.5946 429.051 16.9313 431.845 16.9313C434.638 16.9313 436.258 15.5946 436.258 13.9062C436.258 12.2177 434.638 10.8811 431.845 10.8811ZM442.854 27.9296V1.54773H446V27.9531H442.854V27.9296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7424 25.1625H48.5494V8.81748H60.1929V18.6198H55.0754V15.7354H57.3055V11.7019H51.4368V22.2781H63.855V4.97158H44.8874V25.1625H42V2.08716H66.7424V25.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3578 27.2261L75.6393 15.0553L75.5688 12.5461L84.4423 0L87.8696 2.43886L79.9117 13.6717L86.7898 22.3015L90.9917 15.6181L86.7428 15.9464L86.3907 11.7487L94.8416 11.0921L96.79 14.3049L88.7851 27.0385L85.3578 27.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.467 27.2261L139.185 15.0553L139.256 12.5461L130.406 0L126.955 2.43886L134.913 13.6717L128.035 22.3015L123.833 15.6181L128.105 15.9464L128.434 11.7487L119.983 11.0921L118.035 14.3049L126.04 27.0385L129.467 27.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.556 0.138269L99.7603 1.93945L111.717 27.0825L115.512 25.2813L103.556 0.138269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.731 0.12067L99.2236 25.2571L102.986 27.1255L115.494 1.98906L111.731 0.12067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.395 10.403L142.925 13.8687L146.395 17.3343L149.864 13.8687L146.395 10.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.402 26.3584H147.753L158.622 10.67L151.157 3.96311L153.857 0.937988L163.998 10.0368L155.477 22.3249H162.402V26.3584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.271 26.3584H183.623L194.515 10.67L187.027 3.96311L189.75 0.937988L199.868 10.0368L191.37 22.3249H198.271V26.3584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.808 13.7638L174.65 11.6082L172.493 13.7638L174.65 15.9195L176.808 13.7638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.514 26.3115L165.688 13.9765L174.421 0.961426L183.623 13.3902L174.514 26.3115ZM170.383 13.9061L174.491 19.8157L178.857 13.4137L174.585 8.02005L170.383 13.9061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.938 26.9448L206.276 25.2094L211.558 14.1173H203.647V0.351807H216.558V4.40876H207.708V10.0603H217.967L209.938 26.9448Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_2216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3502 132.682V82.9285H42V68.5266H100.808V82.9285H79.4575V132.682H63.3712H63.3502Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.676 132.683V96.9307H126.79V132.683H111.104V65.6423H126.79V82.8446H147.824C154.541 82.8446 159.341 87.3294 159.341 94.0461V132.683H143.655H143.676Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.735 132.683C176.018 132.683 171.217 128.198 171.217 121.481V94.046C171.217 87.3293 176.018 82.8445 182.735 82.8445H207.938C214.823 82.8445 219.455 87.4767 219.455 94.3618V102.847C219.455 109.732 215.623 113.564 208.738 113.564H186.904V118.933H202.99V115.965H218.676V121.165C218.676 128.05 214.044 132.683 207.159 132.683H182.756H182.735ZM203.769 96.5937H186.883V102.279H203.769V96.5937Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.144 132.683V111.333C257.144 104.448 261.313 100.047 268.029 98.8469L295.233 94.0462V82.8448H273.946V91.6459H257.944V80.1286C257.944 73.2435 262.744 68.4429 269.629 68.4429H299.549C306.434 68.4429 311.235 73.2435 311.235 80.1286V94.7621C311.235 101.647 307.15 106.048 300.349 107.248L273.146 112.049V118.281H310.435V132.683H257.165H257.144Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.986 103.1V82.2551H331.153V103.1H322.015V74.0435H343.429C347.345 74.0435 350.145 76.6543 350.145 80.5706V103.1H341.007H340.986Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.748 103.1C359.832 103.1 357.031 100.405 357.031 96.4674V80.5495C357.031 76.6332 359.832 74.0224 363.748 74.0224H376.023V64H385.161V103.1H363.748ZM376.023 82.234H366.19V94.8672H376.023V82.234Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.497 132.683V122.45L457.128 132.683H432.177C425.292 132.683 420.491 127.882 420.491 120.997V80.1076C420.491 73.2225 425.292 68.4219 432.177 68.4219H468.813C475.698 68.4219 480.499 73.2225 480.499 80.1076V88.993H464.497V82.8238H436.493V118.26H464.497V109.227H451.379V94.6569H480.499V120.976C480.499 127.861 475.698 132.662 468.813 132.662H464.497V132.683Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.254 132.682L520.821 112.048L505.387 132.682H486.185L510.504 99.9623L487.785 68.5266H506.987L520.821 87.9607L534.654 68.5266H553.857L531.306 100.047L555.457 132.682H536.254Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.948 132.683V122.45L598.578 132.683H573.628C566.743 132.683 561.942 127.882 561.942 120.997V80.1076C561.942 73.2225 566.743 68.4219 573.628 68.4219H610.264C617.149 68.4219 621.95 73.2225 621.95 80.1076V88.993H605.948V82.8238H577.944V118.26H605.948V109.227H592.83V94.6569H621.95V120.976C621.95 127.861 617.149 132.662 610.264 132.662H605.948V132.683Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3502 132.682V82.9285H42V68.5266H100.808V82.9285H79.4575V132.682H63.3712H63.3502Z",
    fill: "url(#paint0_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.676 132.683V96.9307H126.79V132.683H111.104V65.6423H126.79V82.8446H147.824C154.541 82.8446 159.341 87.3294 159.341 94.0461V132.683H143.655H143.676Z",
    fill: "url(#paint1_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.735 132.683C176.018 132.683 171.217 128.198 171.217 121.481V94.046C171.217 87.3293 176.018 82.8445 182.735 82.8445H207.938C214.823 82.8445 219.455 87.4767 219.455 94.3618V102.847C219.455 109.732 215.623 113.564 208.738 113.564H186.904V118.933H202.99V115.965H218.676V121.165C218.676 128.05 214.044 132.683 207.159 132.683H182.756H182.735ZM203.769 96.5937H186.883V102.279H203.769V96.5937Z",
    fill: "url(#paint2_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.144 132.683V111.333C257.144 104.448 261.313 100.047 268.029 98.8469L295.233 94.0462V82.8448H273.946V91.6459H257.944V80.1286C257.944 73.2435 262.744 68.4429 269.629 68.4429H299.549C306.434 68.4429 311.235 73.2435 311.235 80.1286V94.7621C311.235 101.647 307.15 106.048 300.349 107.248L273.146 112.049V118.281H310.435V132.683H257.165H257.144Z",
    fill: "url(#paint3_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.986 103.1V82.2551H331.153V103.1H322.015V74.0435H343.429C347.345 74.0435 350.145 76.6543 350.145 80.5706V103.1H341.007H340.986Z",
    fill: "url(#paint4_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.748 103.1C359.832 103.1 357.031 100.405 357.031 96.4674V80.5495C357.031 76.6332 359.832 74.0224 363.748 74.0224H376.023V64H385.161V103.1H363.748ZM376.023 82.234H366.19V94.8672H376.023V82.234Z",
    fill: "url(#paint5_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.497 132.683V122.45L457.128 132.683H432.177C425.292 132.683 420.491 127.882 420.491 120.997V80.1076C420.491 73.2225 425.292 68.4219 432.177 68.4219H468.813C475.698 68.4219 480.499 73.2225 480.499 80.1076V88.993H464.497V82.8238H436.493V118.26H464.497V109.227H451.379V94.6569H480.499V120.976C480.499 127.861 475.698 132.662 468.813 132.662H464.497V132.683Z",
    fill: "url(#paint6_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.254 132.682L520.821 112.048L505.387 132.682H486.185L510.504 99.9623L487.785 68.5266H506.987L520.821 87.9607L534.654 68.5266H553.857L531.306 100.047L555.457 132.682H536.254Z",
    fill: "url(#paint7_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.948 132.683V122.45L598.578 132.683H573.628C566.743 132.683 561.942 127.882 561.942 120.997V80.1076C561.942 73.2225 566.743 68.4219 573.628 68.4219H610.264C617.149 68.4219 621.95 73.2225 621.95 80.1076V88.993H605.948V82.8238H577.944V118.26H605.948V109.227H592.83V94.6569H621.95V120.976C621.95 127.861 617.149 132.662 610.264 132.662H605.948V132.683Z",
    fill: "url(#paint8_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6857 224C46.8006 224 42 219.199 42 212.314V202.229H58.0021V209.598H84.4056V197.596H53.6857C46.8006 197.596 42.8001 193.596 42.8001 186.711V171.425C42.8001 164.539 47.6007 159.739 54.4858 159.739H88.3219C95.207 159.739 100.008 164.539 100.008 171.425V180.226H84.0055V174.141H58.8022V184.374H89.522C96.4071 184.374 100.408 188.374 100.408 195.259V212.293C100.408 219.178 95.607 223.979 88.7219 223.979H53.6857V224Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.895 224C118.01 224 113.209 219.199 113.209 212.314V171.425C113.209 164.539 118.01 159.739 124.895 159.739H159.931C166.816 159.739 171.617 164.539 171.617 171.425V212.314C171.617 219.199 166.816 224 159.931 224H124.895ZM155.615 174.162H129.211V209.598H155.615V174.162Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.252 224C189.367 224 184.566 219.199 184.566 212.314V159.76H200.568V209.598H225.371V159.76H241.373V212.314C241.373 219.199 236.573 224 229.688 224H196.252Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.718 224L279.548 197.681C276.579 192.164 274.747 188.795 271.947 183.363V224H254.513V159.76H273.315L291.149 192.48C293.234 195.996 294.518 198.312 296.497 202.081V159.76H312.499V224H293.697H293.718Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.806 224V159.76H372.275C380.276 159.76 385.877 165.361 385.877 173.362V210.398C385.877 218.399 380.276 224 372.275 224H325.806ZM369.875 174.33H341.787V209.619H369.875V174.33Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.737 224V174.246H422.387V159.844H481.195V174.246H459.845V224H443.758H443.737Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.127 224L522.442 203.682H507.808V224H491.806V159.76H536.444C543.329 159.76 548.129 164.561 548.129 171.446V191.996C548.129 197.597 544.929 201.766 540.128 203.197L552.93 224H534.127ZM532.127 174.162H507.808V189.28H532.127V174.162Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.906 224L601.505 209.598H578.555L573.754 224H556.236L577.586 159.76H603.589L623.424 224H605.906ZM594.072 184.795C592.956 180.794 591.504 176.078 590.704 172.077C589.735 176.078 588.219 180.794 586.935 184.795L583.018 196.312H597.504L594.072 184.795Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.395 224C635.51 224 630.709 219.199 630.709 212.314V171.425C630.709 164.539 635.51 159.739 642.395 159.739H677.347C684.232 159.739 689.032 164.539 689.032 171.425V183.194H673.03V174.162H646.711V209.598H673.03V199.197H689.032V212.314C689.032 219.199 684.232 224 677.347 224H642.395Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.692 224L724.09 199.197L717.605 205.113V224H701.687V159.76H717.605V184.395L740.892 159.76H761.295L735.691 187.279L763.779 224H741.692Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6857 224C46.8006 224 42 219.199 42 212.314V202.229H58.0021V209.598H84.4056V197.596H53.6857C46.8006 197.596 42.8001 193.596 42.8001 186.711V171.425C42.8001 164.539 47.6007 159.739 54.4858 159.739H88.3219C95.207 159.739 100.008 164.539 100.008 171.425V180.226H84.0055V174.141H58.8022V184.374H89.522C96.4071 184.374 100.408 188.374 100.408 195.259V212.293C100.408 219.178 95.607 223.979 88.7219 223.979H53.6857V224Z",
    fill: "url(#paint9_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.895 224C118.01 224 113.209 219.199 113.209 212.314V171.425C113.209 164.539 118.01 159.739 124.895 159.739H159.931C166.816 159.739 171.617 164.539 171.617 171.425V212.314C171.617 219.199 166.816 224 159.931 224H124.895ZM155.615 174.162H129.211V209.598H155.615V174.162Z",
    fill: "url(#paint10_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.252 224C189.367 224 184.566 219.199 184.566 212.314V159.76H200.568V209.598H225.371V159.76H241.373V212.314C241.373 219.199 236.573 224 229.688 224H196.252Z",
    fill: "url(#paint11_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.718 224L279.548 197.681C276.579 192.164 274.747 188.795 271.947 183.363V224H254.513V159.76H273.315L291.149 192.48C293.234 195.996 294.518 198.312 296.497 202.081V159.76H312.499V224H293.697H293.718Z",
    fill: "url(#paint12_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.806 224V159.76H372.275C380.276 159.76 385.877 165.361 385.877 173.362V210.398C385.877 218.399 380.276 224 372.275 224H325.806ZM369.875 174.33H341.787V209.619H369.875V174.33Z",
    fill: "url(#paint13_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.737 224V174.246H422.387V159.844H481.195V174.246H459.845V224H443.758H443.737Z",
    fill: "url(#paint14_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.127 224L522.442 203.682H507.808V224H491.806V159.76H536.444C543.329 159.76 548.129 164.561 548.129 171.446V191.996C548.129 197.597 544.929 201.766 540.128 203.197L552.93 224H534.127ZM532.127 174.162H507.808V189.28H532.127V174.162Z",
    fill: "url(#paint15_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.906 224L601.505 209.598H578.555L573.754 224H556.236L577.586 159.76H603.589L623.424 224H605.906ZM594.072 184.795C592.956 180.794 591.504 176.078 590.704 172.077C589.735 176.078 588.219 180.794 586.935 184.795L583.018 196.312H597.504L594.072 184.795Z",
    fill: "url(#paint16_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.395 224C635.51 224 630.709 219.199 630.709 212.314V171.425C630.709 164.539 635.51 159.739 642.395 159.739H677.347C684.232 159.739 689.032 164.539 689.032 171.425V183.194H673.03V174.162H646.711V209.598H673.03V199.197H689.032V212.314C689.032 219.199 684.232 224 677.347 224H642.395Z",
    fill: "url(#paint17_linear_31_2216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.692 224L724.09 199.197L717.605 205.113V224H701.687V159.76H717.605V184.395L740.892 159.76H761.295L735.691 187.279L763.779 224H741.692Z",
    fill: "url(#paint18_linear_31_2216)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8 287.2C71.1867 287.2 72.3733 287.373 73.36 287.72C74.3733 288.04 75.2 288.493 75.84 289.08C76.5067 289.667 77 290.36 77.32 291.16C77.64 291.933 77.8 292.76 77.8 293.64C77.8 294.52 77.6267 295.347 77.28 296.12C76.96 296.893 76.4667 297.573 75.8 298.16C75.1333 298.747 74.2933 299.2 73.28 299.52C72.2667 299.867 71.0667 300.04 69.68 300.04H52.12C50.7333 300.04 49.5467 299.867 48.56 299.52C47.5733 299.2 46.76 298.747 46.12 298.16C45.48 297.573 45 296.893 44.68 296.12C44.3867 295.347 44.24 294.52 44.24 293.64C44.24 292.76 44.4 291.933 44.72 291.16C45.04 290.36 45.52 289.667 46.16 289.08C46.8267 288.493 47.6533 288.04 48.64 287.72C49.6533 287.373 50.8533 287.2 52.24 287.2H69.8ZM76.84 279.36C74.0933 278.827 71.4267 278.307 68.84 277.8C66.2533 277.267 63.64 276.653 61 275.96C58.3333 276.653 55.7067 277.267 53.12 277.8C50.5333 278.307 47.8667 278.827 45.12 279.36L43.48 274.16C45.5333 273.733 47.5467 273.307 49.52 272.88C51.4933 272.427 53.48 271.907 55.48 271.32C55.9333 271.187 56.2533 271.027 56.44 270.84H45.08V265.44H56.4V263.12H65.6V265.44H76.96V270.84H65.52C65.6533 271.027 65.9867 271.187 66.52 271.32C68.52 271.907 70.4933 272.427 72.44 272.88C74.4133 273.307 76.44 273.733 78.52 274.16L76.84 279.36ZM78.64 285.88H43.36V280.44H56.52V277.76H65.48V280.44H78.64V285.88ZM68.04 294.52C68.6533 294.52 69.1333 294.453 69.48 294.32C69.8533 294.187 70.04 293.96 70.04 293.64C70.04 293.027 69.3733 292.72 68.04 292.72H54.04C52.7067 292.72 52.04 293.027 52.04 293.64C52.04 293.96 52.2133 294.187 52.56 294.32C52.9333 294.453 53.4267 294.52 54.04 294.52H68.04ZM107.328 284.04C108.714 284.04 109.914 284.253 110.928 284.68C111.941 285.107 112.768 285.693 113.408 286.44C114.074 287.16 114.568 288.013 114.888 289C115.208 289.96 115.368 290.973 115.368 292.04C115.368 293.107 115.194 294.12 114.848 295.08C114.528 296.067 114.034 296.92 113.368 297.64C112.701 298.387 111.848 298.973 110.808 299.4C109.794 299.827 108.594 300.04 107.208 300.04H90.7278C89.3411 300.04 88.1411 299.827 87.1278 299.4C86.1411 298.973 85.3278 298.387 84.6878 297.64C84.0478 296.92 83.5678 296.067 83.2478 295.08C82.9545 294.12 82.8078 293.107 82.8078 292.04C82.8078 290.973 82.9678 289.96 83.2878 289C83.6078 288.013 84.0878 287.16 84.7278 286.44C85.3945 285.693 86.2345 285.107 87.2478 284.68C88.2611 284.253 89.4611 284.04 90.8478 284.04H107.328ZM100.768 282.96C99.3811 282.027 98.0078 281.067 96.6478 280.08C95.3145 279.093 94.0211 277.987 92.7678 276.76C91.4878 277.933 90.1545 279.027 88.7678 280.04C87.4078 281.053 85.9411 282.08 84.3678 283.12L79.8878 277.8C81.3811 276.68 82.7678 275.6 84.0478 274.56C85.3545 273.52 86.5678 272.4 87.6878 271.2C88.0611 270.827 88.3011 270.467 88.4078 270.12C88.5145 269.773 88.5678 269.32 88.5678 268.76V264.08H96.9678V268.72C96.9678 269.227 97.0211 269.667 97.1278 270.04C97.2345 270.413 97.4611 270.787 97.8078 271.16C98.9011 272.333 100.061 273.453 101.288 274.52C102.514 275.56 103.821 276.64 105.208 277.76L100.768 282.96ZM114.008 283.12H106.168V264.08H114.008V269.6H117.928V276.32H114.008V283.12ZM105.528 293.52C106.141 293.52 106.621 293.387 106.968 293.12C107.341 292.853 107.528 292.493 107.528 292.04C107.528 291.587 107.354 291.227 107.008 290.96C106.661 290.667 106.168 290.52 105.528 290.52H92.6478C92.0078 290.52 91.5145 290.667 91.1678 290.96C90.8211 291.227 90.6478 291.587 90.6478 292.04C90.6478 292.493 90.8211 292.853 91.1678 293.12C91.5411 293.387 92.0345 293.52 92.6478 293.52H105.528ZM154.656 283H119.376V276.92H144.976V270.28H121.216V264.2H152.816V276.92H154.656V283ZM152.816 299.4H144.976V295.72L141.296 299.4H121.216V285H152.816V299.4ZM144.976 293.32V291.08H129.056V293.32H144.976Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.759 297.52H169.119V286.84C169.119 285.107 169.599 283.707 170.559 282.64C171.546 281.573 172.879 280.893 174.559 280.6L188.159 278.2V272.6H177.519V277H169.519V271.24C169.519 269.507 170.052 268.107 171.119 267.04C172.212 265.947 173.626 265.4 175.359 265.4H190.319C192.052 265.4 193.452 265.947 194.519 267.04C195.612 268.107 196.159 269.507 196.159 271.24V278.56C196.159 280.293 195.679 281.693 194.719 282.76C193.759 283.827 192.426 284.507 190.719 284.8L177.119 287.2V290.32H195.759V297.52ZM204.85 303.16H198.85L200.45 290.4H208.41L204.85 303.16ZM222.892 297.52H214.492V272.6H210.652V265.4H222.892V297.52ZM254.831 291.68C254.831 293.413 254.284 294.813 253.191 295.88C252.124 296.973 250.724 297.52 248.991 297.52H233.631C231.898 297.52 230.484 296.973 229.391 295.88C228.324 294.813 227.791 293.413 227.791 291.68V271.24C227.791 269.507 228.324 268.107 229.391 267.04C230.484 265.947 231.898 265.4 233.631 265.4H248.991C250.724 265.4 252.124 265.947 253.191 267.04C254.284 268.107 254.831 269.507 254.831 271.24V291.68ZM246.831 290.32V272.6H235.791V290.32H246.831ZM286.042 291.68C286.042 293.413 285.495 294.813 284.402 295.88C283.335 296.973 281.935 297.52 280.202 297.52H264.842C263.109 297.52 261.695 296.973 260.602 295.88C259.535 294.813 259.002 293.413 259.002 291.68V271.24C259.002 269.507 259.535 268.107 260.602 267.04C261.695 265.947 263.109 265.4 264.842 265.4H280.202C281.935 265.4 283.335 265.947 284.402 267.04C285.495 268.107 286.042 269.507 286.042 271.24V291.68ZM278.042 290.32V272.6H267.002V290.32H278.042ZM311.173 283.88H290.093V264.48H311.173V283.88ZM322.733 299.4H292.293V286.24H300.133V292.84H322.733V299.4ZM322.133 289.4H314.293V264.08H322.133V271.12H326.053V277.84H322.133V289.4ZM303.333 277.28V271.08H297.933V277.28H303.333ZM361.541 291.52H353.701V290.28H344.861V285.28H353.701V281.2L350.981 283.92H342.901V289.16H334.861V283.92H327.301V278.52H353.701V264.08H361.541V291.52ZM336.461 277.16C333.821 277.16 331.741 276.573 330.221 275.4C328.727 274.2 327.981 272.533 327.981 270.4C327.981 268.24 328.727 266.573 330.221 265.4C331.741 264.2 333.821 263.6 336.461 263.6H343.421C346.061 263.6 348.127 264.2 349.621 265.4C351.141 266.573 351.901 268.24 351.901 270.4C351.901 272.533 351.141 274.2 349.621 275.4C348.127 276.573 346.061 277.16 343.421 277.16H336.461ZM361.701 299.4H330.341V290.08H338.181V293.8H361.701V299.4ZM342.021 271.76C342.634 271.76 343.127 271.653 343.501 271.44C343.874 271.2 344.061 270.84 344.061 270.36C344.061 269.88 343.874 269.533 343.501 269.32C343.127 269.107 342.634 269 342.021 269H337.861C337.247 269 336.754 269.107 336.381 269.32C336.007 269.533 335.821 269.88 335.821 270.36C335.821 270.84 336.007 271.2 336.381 271.44C336.754 271.653 337.247 271.76 337.861 271.76H342.021Z",
    fill: "#98A6CB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_2216",
    x: 0,
    y: 22,
    width: 805.779,
    height: 244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_2216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_2216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_2216",
    x1: -25.5878,
    y1: 144.01,
    x2: 683.369,
    y2: 144.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_2216",
    x1: -25.5881,
    y1: 144.011,
    x2: 683.368,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_2216",
    x1: -25.5875,
    y1: 144.01,
    x2: 683.369,
    y2: 144.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_2216",
    x1: -25.5884,
    y1: 144.011,
    x2: 683.368,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31_2216",
    x1: -25.5885,
    y1: 144.011,
    x2: 683.368,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_31_2216",
    x1: -25.5875,
    y1: 144.011,
    x2: 683.369,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31_2216",
    x1: -25.5884,
    y1: 144.011,
    x2: 683.368,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_31_2216",
    x1: -25.5879,
    y1: 144.01,
    x2: 683.368,
    y2: 144.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_31_2216",
    x1: -25.5879,
    y1: 144.011,
    x2: 683.368,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_31_2216",
    x1: 42,
    y1: 144.01,
    x2: 750.956,
    y2: 144.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_31_2216",
    x1: 41.9996,
    y1: 144.01,
    x2: 750.956,
    y2: 144.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_31_2216",
    x1: 41.9998,
    y1: 144.011,
    x2: 750.956,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_31_2216",
    x1: 42.0006,
    y1: 144.011,
    x2: 750.957,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_31_2216",
    x1: 42,
    y1: 144.011,
    x2: 750.956,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_31_2216",
    x1: 42.0005,
    y1: 144.011,
    x2: 750.957,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_31_2216",
    x1: 41.9999,
    y1: 144.011,
    x2: 750.956,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_31_2216",
    x1: 41.9998,
    y1: 144.011,
    x2: 750.956,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_31_2216",
    x1: 41.9998,
    y1: 144.01,
    x2: 750.956,
    y2: 144.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_31_2216",
    x1: 42.0005,
    y1: 144.011,
    x2: 750.957,
    y2: 144.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 28,
    fill: "white",
    transform: "translate(42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTxt);
export default __webpack_public_path__ + "static/media/landingTxt.c40ed369cfecc3932967bf7d982c34a9.svg";
export { ForwardRef as ReactComponent };